import { render, staticRenderFns } from "./shift-copy.vue?vue&type=template&id=02f11fd4&"
import script from "./shift-copy.vue?vue&type=script&lang=js&"
export * from "./shift-copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "shift-copy.vue"
export default component.exports